import { gql, useMutation } from '@apollo/client';

const CREATE_GLOBAL_DOWNLOAD_MUTATION = gql`
  mutation createGlobalDownload($downloadType: DownloadTypeEnum!) {
    createGlobalDownload(downloadType: $downloadType) {
      userDownload {
        downloadType
        filename
        status
        errorMessage
      }
    }
  }
`;

export const useGlobalDownloads = () => {
  const [createGlobalDownloadMutation, { data, loading, error }] = useMutation(
    CREATE_GLOBAL_DOWNLOAD_MUTATION,
  );
  const createGlobalDownload = async ({ downloadType }) => {
    return await createGlobalDownloadMutation({
      variables: { downloadType },
    });
  };

  return {
    createGlobalDownload,
    data,
    loading,
    error,
  };
};
